export const titleText = [
    {
        title: "ИГРОВОЙ МАГАЗИН",
    },
    {
        title: "ИЗБРАННОЕ",
    }
];